import clsx from 'clsx';
import { FC } from 'react';

import { SECTIONS_IDS } from '../../../constants/sections';
import { useLkBasePath } from '../../../hooks/use-lk-base-path';
import { useMainLandingSectionHrefFactory } from '../../../hooks/use-main-landing-href';
import { WithClassName } from '../../../types/react';
import { BurgerV4Icon } from '../../icons/BurderV4Icon';
import { ButtonLink } from '../common/ButtonLink';
import { Flex } from '../common/Flex';
import { Link } from '../common/Link';
import { Logo } from '../common/Logo';
import { LogoText } from '../common/LogoText';
import { TextLink } from '../common/TextLink';

import { MobileModalMenu } from './components/MobileModalMenu';
import styles from './Header.module.scss';

type HeaderProps = WithClassName & {};

export const Header: FC<HeaderProps> = (props) => {
  const { className } = props;

  const lkBasePath = useLkBasePath();
  const sectionHref = useMainLandingSectionHrefFactory();

  return (
    <header className={clsx(styles.root, className)}>
      <Flex className={styles.desktopHeader} alignItems="center" wrap="nowrap" childMinSize="unset">
        <Link className={styles.logoLink} href={sectionHref(SECTIONS_IDS.first)}>
          <Flex className={styles.logoContainer} gap={3} alignItems="center" justifyContent="center">
            <LogoText />

            <Logo />
          </Flex>
        </Link>

        <Flex className={styles.linksContainer} alignItems="center" wrap="nowrap" childMinSize="unset">
          <TextLink href={sectionHref(SECTIONS_IDS.products)} variant="white-50p">
            What we do
          </TextLink>

          <TextLink href={sectionHref(SECTIONS_IDS.solutions)} variant="white-50p">
            Solutions
          </TextLink>

          <TextLink href={sectionHref(SECTIONS_IDS.developers)} variant="white-50p">
            Developers
          </TextLink>

          <TextLink href={sectionHref(SECTIONS_IDS.resources)} variant="white-50p">
            Resources
          </TextLink>

          <TextLink href="/why-sg" variant="white-50p">
            Why SmartGates
          </TextLink>

          <TextLink href="/integrations" variant="white-50p">
            Integrations
          </TextLink>
        </Flex>

        <Flex className={styles.loginBlock} gap={6} alignItems="center" wrap="nowrap" childMinSize="unset">
          <TextLink href={`${lkBasePath}/account/login`} isOutsideLink>
            Log in
          </TextLink>

          <ButtonLink href={sectionHref(SECTIONS_IDS.contact)}>Contact</ButtonLink>
        </Flex>
      </Flex>

      <Flex className={styles.mobileHeader} alignItems="center" justifyContent="spaceBetween">
        <Link href={sectionHref(SECTIONS_IDS.first)}>
          <Logo />
        </Link>

        <MobileModalMenu>
          <Flex className={styles.burgerContainer} alignItems="center" justifyContent="center">
            <BurgerV4Icon />
          </Flex>
        </MobileModalMenu>
      </Flex>
    </header>
  );
};
